export function formatToolName(toolName) {
  if (!toolName) {
    return 'N/A'
  }

  return toolName
    .replace(/_/g, ' ')
    .replace(/\b\w/g, l => l.toUpperCase())
}

export function formatExecutionTime(ms) {
  if (ms == null || ms === '') {
    return 'N/A'
  }

  const value = Number(ms)
  if (Number.isNaN(value)) {
    return 'N/A'
  }

  if (value < 1000) {
    return `${value}ms`
  }

  return `${(value / 1000).toFixed(2)}s`
}

export function formatJson(value) {
  if (value == null || value === '') {
    return '—'
  }

  if (typeof value === 'string') {
    return value
  }

  try {
    return JSON.stringify(value, null, 2)
  } catch (e) {
    return String(value)
  }
}

export function scrollChatToBottom(container) {
  if (!container) {
    return
  }

  requestAnimationFrame(() => {
    container.scrollTop = container.scrollHeight
  })
}

export function aguardar(milisegundos) {
  return new Promise(resolve => {
    setTimeout(resolve, milisegundos)
  })
}

export function formatarDataHoraAgora() {
  const agora = new Date()
  const dia = String(agora.getDate()).padStart(2, '0')
  const mes = String(agora.getMonth() + 1).padStart(2, '0')
  const ano = agora.getFullYear()
  const hora = String(agora.getHours()).padStart(2, '0')
  const minuto = String(agora.getMinutes()).padStart(2, '0')
  const segundo = String(agora.getSeconds()).padStart(2, '0')

  return `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`
}

export function intervaloRevelacaoMensagem(mensagem) {
  if (mensagem?.papel === 'tool') {
    return 280
  }

  if (mensagem?.papel === 'assistant') {
    return 520
  }

  return 320
}

export function executionContextLabel(context) {
  const map = {
    normal: 'Normal',
    cobranca: 'Cobrança',
    finalizacao: 'Finalização',
    tempo: 'Verificação de Função',
  }

  return map[context] || context || 'Normal'
}
